import httpRequest from './httpRequest';
import { getBaseRequestConfig, LOCAL_BASE_PATH } from './baseRequestConfig';

export function putUser(user, userId, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${LOCAL_BASE_PATH}/profile/${userId}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'PUT',
    data: user,
  });

  return httpRequest(requestConfig);
}

export function putUserPassword(password, userId, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${LOCAL_BASE_PATH}/profile/${userId}/changePassword`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'PUT',
    data: password,
  });

  return httpRequest(requestConfig);
}
